import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { TranslateService } from '@ngx-translate/core';
import { TextModel } from 'src/models/text';
import { TextService } from '../../services/text.service';
import { AuthService } from 'src/services/guard/auth.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-usefull-addresses',
  templateUrl: './usefull-addresses.component.html',
  styleUrls: ['./usefull-addresses.component.scss']
})
export class UsefullAddressesComponent extends BaseComponent implements OnInit {

  addresses1: TextModel = new TextModel();
  textModel: TextModel;
  modalRef: BsModalRef;

  constructor(
    public translate: TranslateService,
    private textService: TextService,
    authService: AuthService,
    private modalService: BsModalService,
    private toast: ToastrService,
    deviceDetectorService: DeviceDetectorService,
    route: ActivatedRoute
  ) {
    super(translate, authService, deviceDetectorService, route);
    this.langChange.subscribe(lg => this.getText());
  }

  ngOnInit(): void {
    this.getText();
  }

  getText() {
    this.textService.getText('addresses1.txt', this.translate.currentLang).subscribe(
      data => {
        this.addresses1.textId = 'addresses1.txt';
        this.addresses1.lang = this.translate.currentLang;
        this.addresses1.text = data;
      }
    );
  }

  updateText(text: TextModel, template: TemplateRef<any>) {
    if (!this.isAdmin) {
      return;
    }
    this.textModel = new TextModel();
    Object.assign(this.textModel, text);
    this.modalRef = this.modalService.show(template);
  }

  saveText() {
    this.textService.saveText(this.textModel).subscribe(
      () => this.toast.success('Text saved!'),
      err => {
        console.error(err);
        this.toast.error('Error while saving the text...');
      },
      () => {
        this.getText();
        this.modalRef.hide();
      }
    );
  }

}
